import React from "react";
import Navbar from "../../layout/Navbar";
import Footer from "../../layout/Footer";
import calundum from "../../assets/Our Products/Refractory Cement/calundum-1.jpg";
import dataSheetImg from "../../assets/Our Products/Refractory Cement/data-refre-cement.png";

const Refractory_Cement = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* About Refractory Cement Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-10 items-center">
          {/* Text Section */}
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              About <span className="text-orange-600">Refractory Cement</span>
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              JANTA Group manufactures High Purity High Alumina Binders(Refractory Cement) in a state of the art plant under stringent process control. Setting characteristics and Strength properties of these binders contribute in a major way behind successful application and performance of castable refractories.High alumina binder is manufactured for all type of low ferric conventional and insulating castable.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              We are manufacturing two types of binders which are Calundum-50 and KLAL-70.
            </p>
          </div>

          {/* Image Section */}
          <div className="flex justify-center md:justify-end relative">
            <img
              src={calundum}
              alt="Calundum"
              className="w-80 h-80 object-cover rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </section>

      {/* Data Sheet Section (with Image) */}
      <section className="py-16 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-10">
            Product Data Sheet for <span className="text-orange-500">BED MATERIALS</span>
          </h2>

          <div className="flex justify-center">
            <img
              src={dataSheetImg}
              alt="Bed Materials Data Sheet"
              className="rounded-1xl shadow-2xl border border-white/20 w-full sm:w-[80%] md:w-[70%] object-contain"
            />
          </div>
        </div>
      </section>

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease-out forwards;
          opacity: 0;
        }
      `}</style>

      <Footer />
    </div>
  );
};

export default Refractory_Cement;

